// src/sanityClient.js
import { createClient } from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

// Put your real values here:
const projectId = "nkz5y69g";     // from your Sanity URL / screenshot
const dataset = "production";     // usually "production"

export const sanity = createClient({
  projectId,
  dataset,
  apiVersion: "2025-01-01",
  useCdn: true
});

const builder = imageUrlBuilder(sanity);
export const urlFor = (source) => builder.image(source);